/* @flow */

import { rem } from 'polished';

import { disabledOpacity } from 'src/shared/app/base/style/token/opacity';
import {
  baseFontSize,
  inputFontSize,
  inputFontWeight,
  inputLineHeight,
} from '@braindate/ui/lib/token/typography';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

const textInput =
  'input:not([type=checkbox]):not([type=radio]):not([list]):not([type=range])';

export default {
  [textInput]: {
    // Show the overflow in Edge
    overflow: 'visible',
  },
  textarea: {
    // Remove the default vertical scrollbar in IE 10+.
    overflow: 'auto',
    width: '100%',

    // Prevent resizing
    resize: 'none',
  },
  [`${textInput}, textarea`]: {
    // Remove the margin in Firefox and Safari
    margin: 0,
    padding: rem(4, baseFontSize),
    color: ({ theme }: ThemeFunction) => theme.textColor,

    backgroundColor: 'transparent',
    border: () => 0,
    borderBottom: ({ theme }: ThemeFunction) => `solid 1px ${theme.textColor}`,
    appearance: 'none',
    // Hide highlight occuring when an input is being tapped on WebKit
    WebkitTapHighlightColor: 'transparent',

    // Change the font styles in all browsers
    fontFamily: 'inherit',
    fontSize: rem(inputFontSize, baseFontSize),
    fontWeight: inputFontWeight,
    lineHeight: inputLineHeight / inputFontSize,

    '&:focus': {
      outlineStyle: 'solid',
      outlineWidth: 1,
      outlineOffset: 2,
    },
    '&:disabled': {
      opacity: disabledOpacity,
    },

    // Next selectors are nested for greater specificity
    '&[type=number]': {
      // Remove increment button in Firefox
      MozAppearance: 'textfield',

      // Remove increment button in Webkit
      '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
        WebkitAppearance: 'none',
      },
    },
    '&[type=search]': {
      // Correct the outline style in Safari
      outlineOffset: -2,
      // Correct the odd appearance in Chrome and Safari
      WebkitAppearance: 'textfield',

      '&::-webkit-search-decoration': {
        // Remove the inner padding in Chrome and Safari on macOS
        WebkitAppearance: 'none',
      },
    },
    '&[type=password]': {
      // Hide lock icon on Safari
      '&::-webkit-credentials-auto-fill-button': {
        visibility: 'hidden',
      },
    },
  },
};
